module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0002.jpg?v=fa0688af";